import React from "react";

export const SideNav = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16">
      <g id="menu-right-alt" transform="translate(0)">
        <path
          id="Path_1"
          data-name="Path 1"
          d="M4,6.522A1.511,1.511,0,0,1,5.5,5h21a1.523,1.523,0,0,1,0,3.045H5.5A1.511,1.511,0,0,1,4,6.522Z"
          transform="translate(-4 -5)"
        />
        <path
          id="Path_2"
          data-name="Path 2"
          d="M4,18.522A1.511,1.511,0,0,1,5.5,17h21a1.523,1.523,0,0,1,0,3.045H5.5A1.511,1.511,0,0,1,4,18.522Z"
          transform="translate(-4 -4.045)"
        />
        <path
          id="Path_3"
          data-name="Path 3"
          d="M11.523,11a1.522,1.522,0,0,0,0,3.045H23.7A1.522,1.522,0,0,0,23.7,11Z"
          transform="translate(-1.225 -4.523)"
        />
      </g>
    </svg>
  );
};

export const SimApps = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
      <g id="Group_2822" data-name="Group 2822" transform="translate(-1848 -23)">
        <g id="Group_2823" data-name="Group 2823" transform="translate(-2144 -1086)">
          <g id="Group_2826" data-name="Group 2826" transform="translate(-4)">
            <g id="Path_14087" data-name="Path 14087" transform="translate(4016 1129)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g id="Path_14088" data-name="Path 14088" transform="translate(4016 1119)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g id="Path_14093" data-name="Path 14093" transform="translate(4016 1109)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
          </g>
          <g id="Group_2825" data-name="Group 2825" transform="translate(-2)">
            <g id="Path_14086" data-name="Path 14086" transform="translate(4004 1129)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g id="Path_14089" data-name="Path 14089" transform="translate(4004 1119)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g id="Path_14092" data-name="Path 14092" transform="translate(4004 1109)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
          </g>
          <g id="Group_2824" data-name="Group 2824">
            <g id="Path_14085" data-name="Path 14085" transform="translate(3992 1129)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g id="Path_14090" data-name="Path 14090" transform="translate(3992 1119)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g id="Path_14091" data-name="Path 14091" transform="translate(3992 1109)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const CategoriesSideIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23.845" height="23.845" viewBox="0 0 23.845 23.845">
      <g id="dashboard" transform="translate(0.15 0.15)">
        <path
          id="Path_8284"
          data-name="Path 8284"
          d="M24,21h1.512v3.78H24Z"
          transform="translate(-7.722 -6.976)"
          fill="#fff"
          stroke="#fff"
          strokeWidth="0.3"
        ></path>
        <path
          id="Path_8285"
          data-name="Path 8285"
          d="M20,16h1.512v7.56H20Z"
          transform="translate(-6.682 -5.724)"
          fill="#fff"
          stroke="#fff"
          strokeWidth="0.3"
        ></path>
        <path
          id="Path_8286"
          data-name="Path 8286"
          d="M9.78,23.56A3.784,3.784,0,0,1,6,19.78H7.512A2.268,2.268,0,1,0,9.78,17.512V16a3.78,3.78,0,0,1,0,7.56Z"
          transform="translate(-2.976 -5.724)"
          fill="#fff"
          stroke="#fff"
          strokeWidth="0.3"
        ></path>
        <path
          id="Path_8287"
          data-name="Path 8287"
          d="M23.863,2H3.682A1.683,1.683,0,0,0,2,3.682V23.863a1.683,1.683,0,0,0,1.682,1.682H23.863a1.684,1.684,0,0,0,1.682-1.682V3.682A1.683,1.683,0,0,0,23.863,2Zm0,7.568H12.091V3.682H23.863ZM10.409,3.682V9.568H3.682V3.682ZM3.682,23.863V11.25H23.863l0,12.613Z"
          transform="translate(-2 -2)"
          fill="#fff"
          stroke="#fff"
          strokeWidth="0.3"
        ></path>
      </g>{" "}
    </svg>
  );
};

export const MyDashBoardIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23.223" height="23.223" viewBox="0 0 23.223 23.223">
      <path
        id="dashboard_FILL0_wght400_GRAD0_opsz24"
        d="M132.9-832.259V-840h10.321v7.741ZM120-827.1V-840h10.321v12.9Zm12.9,10.321v-12.9h10.321v12.9Zm-12.9,0v-7.741h10.321v7.741Zm1.58-11.9h7.161v-9.741H121.58Zm12.9,10.321h7.161V-828.1h-7.161Zm0-15.482h7.161v-4.58h-7.161Zm-12.9,15.482h7.161v-4.58H121.58Z"
        transform="translate(-120 840)"
        fill="#333"
      />
    </svg>
  );
};

export const ProductsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-box-seam"
      viewBox="0 0 16 16"
    >
      <path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5l2.404.961L10.404 2zm3.564 1.426L5.596 5 8 5.961 14.154 3.5zm3.25 1.7-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464z" />
    </svg>
  );
};

export const SearchesCIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20">
      <g id="Search_icon" data-name="Search icon" transform="translate(0.001 0)" opacity="0.5">
        <path
          id="Ellipse_642"
          data-name="Ellipse 642"
          d="M9,1.5A7.5,7.5,0,1,0,16.5,9,7.508,7.508,0,0,0,9,1.5M9,0A9,9,0,1,1,0,9,9,9,0,0,1,9,0Z"
          transform="translate(-0.001 0)"
          fill="#333"
        />
        <path
          id="Ellipse_643"
          data-name="Ellipse 643"
          d="M2.5,0A2.5,2.5,0,1,1,0,2.5,2.5,2.5,0,0,1,2.5,0Z"
          transform="translate(15.999 15)"
          fill="#333"
        />
      </g>
    </svg>
  );
};

export const CancelIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-x"
      viewBox="0 0 16 16"
    >
      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
    </svg>
  );
};

export const FilterIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21.297" height="19.35" viewBox="0 0 21.297 19.35">
      <g id="Group_4203" data-name="Group 4203" transform="translate(0 -1)">
        <path
          id="Path_15265"
          data-name="Path 15265"
          d="M17.51,12.814a3.768,3.768,0,1,1-3.79,3.768A3.782,3.782,0,0,1,17.51,12.814Zm0,1.825a1.942,1.942,0,1,0,1.962,1.942A1.956,1.956,0,0,0,17.51,14.64ZM8.616,15.717a.913.913,0,1,1,0,1.825H.948a.913.913,0,1,1,0-1.825ZM3.788,1A3.768,3.768,0,1,1,0,4.769,3.783,3.783,0,0,1,3.788,1Zm0,1.825A1.942,1.942,0,1,0,5.751,4.769,1.956,1.956,0,0,0,3.788,2.825ZM19.7,3.921a.913.913,0,0,1,0,1.825H12.037a.913.913,0,0,1,0-1.825Z"
          fill="#fff"
          fillRule="evenodd"
        ></path>
      </g>
    </svg>
  );
};

export const DateFilterIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="#fff"
    className="bi bi-funnel-fill"
    viewBox="0 0 16 16"
  >
    <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5z" />
  </svg>
);

export const EditIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g id="Group_3141" data-name="Group 3141" transform="translate(-24.2 -24.2)">
        <path
          id="Path_14272"
          data-name="Path 14272"
          d="M29.781,48.2H42.619A5.6,5.6,0,0,0,48.2,42.619h0V38.991a.93.93,0,0,0-1.86,0v3.628a3.732,3.732,0,0,1-3.721,3.721H29.781a3.732,3.732,0,0,1-3.721-3.721V29.781a3.732,3.732,0,0,1,3.721-3.721h3.628a.93.93,0,0,0,0-1.86H29.781A5.6,5.6,0,0,0,24.2,29.781V42.619A5.6,5.6,0,0,0,29.781,48.2Z"
          fill="#333"
        />
        <path
          id="Path_14273"
          data-name="Path 14273"
          d="M50.482,25.677l-9.488,9.488a.9.9,0,0,0-.233.419l-1.3,4.651A.93.93,0,0,0,40.11,41.4a.951.951,0,0,0,.512,0l4.651-1.3a1.886,1.886,0,0,0,.419-.233l9.535-9.488a3.313,3.313,0,0,0,0-4.7,3.369,3.369,0,0,0-4.744,0ZM41.645,39.165l.465-1.581,1.163,1.163Zm12.186-10.14L45.04,37.816,42.994,35.77l8.791-8.791a1.462,1.462,0,0,1,2.047.14A1.478,1.478,0,0,1,53.831,29.026Z"
          transform="translate(-8.142 -0.267)"
          fill="#333"
        />
      </g>
    </svg>
  );
};

export const BreadcrumbRight = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="p-icon p-breadcrumb-chevron"
      aria-hidden="true"
      data-pc-section="separatoricon"
    >
      <path
        d="M4.38708 13C4.28408 13.0005 4.18203 12.9804 4.08691 12.9409C3.99178 12.9014 3.9055 12.8433 3.83313 12.7701C3.68634 12.6231 3.60388 12.4238 3.60388 12.2161C3.60388 12.0084 3.68634 11.8091 3.83313 11.6622L8.50507 6.99022L3.83313 2.31827C3.69467 2.16968 3.61928 1.97313 3.62287 1.77005C3.62645 1.56698 3.70872 1.37322 3.85234 1.22959C3.99596 1.08597 4.18972 1.00371 4.3928 1.00012C4.59588 0.996539 4.79242 1.07192 4.94102 1.21039L10.1669 6.43628C10.3137 6.58325 10.3962 6.78249 10.3962 6.99022C10.3962 7.19795 10.3137 7.39718 10.1669 7.54416L4.94102 12.7701C4.86865 12.8433 4.78237 12.9014 4.68724 12.9409C4.59212 12.9804 4.49007 13.0005 4.38708 13Z"
        fill="currentColor"
      ></path>
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-x"
      viewBox="0 0 16 16"
    >
      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-trash3"
      viewBox="0 0 16 16"
    >
      <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
    </svg>
  );
};

export const CategoryIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" id="category">
      <path d="M907.9 875.8H116.7c-2.6 0-5.2-.1-7.8-.5 2.7.4 5.3.7 8 1.1-4.5-.7-8.8-1.8-12.9-3.5l7.2 3c-2.8-1.2-5.5-2.6-8.1-4.3-5.6-3.7 2.9 2.7 1.3 1.2-1.1-1.1-2.3-2-3.4-3.1-.9-.9-1.8-1.9-2.7-2.9-3.3-3.6 4.8 6.9.8.8-1.7-2.6-3.1-5.3-4.3-8.1l3 7.2c-1.7-4.2-2.9-8.5-3.5-12.9.4 2.7.7 5.3 1.1 8-1-7.8-.5-16-.5-23.9V170.1c0-2.6.2-5.1.5-7.7-.4 2.7-.7 5.3-1.1 8 .7-4.5 1.8-8.8 3.5-12.9l-3 7.2c1.2-2.8 2.6-5.5 4.3-8.1 3.7-5.6-2.7 2.9-1.2 1.3 1.1-1.1 2-2.3 3.1-3.4.9-.9 1.9-1.8 2.9-2.7 3.6-3.3-6.9 4.8-.8.8 2.6-1.7 5.3-3.1 8.1-4.3l-7.2 3c4.2-1.7 8.5-2.9 12.9-3.5-2.7.4-5.3.7-8 1.1 9.8-1.2 20.1-.5 30-.5h198.2c11.8 0 24.2-1 35.9.4-2.7-.4-5.3-.7-8-1.1 3.6.6 6.9 1.5 10.3 2.8l-7.2-3c2.4 1 4.5 2.3 6.7 3.5 5 2.7-5.3-5-1.2-1 .9.9 1.9 1.7 2.8 2.6.7.7 1.4 1.5 2.1 2.3 1.4 1.6 2.8 3.2 4.2 4.9 6.2 7.2 12.5 14.4 18.7 21.5 17.5 20.2 35.1 40.4 52.6 60.6 6.8 7.8 13.5 15.6 20.3 23.4 7.9 9.2 13.8 16.5 28.3 17 7.3.2 14.7 0 22 0h293.8c29.5 0 59-.1 88.4 0 2.6 0 5.2.2 7.8.5-2.7-.4-5.3-.7-8-1.1 4.5.7 8.8 1.8 12.9 3.5l-7.2-3c2.8 1.2 5.5 2.6 8.1 4.3 5.6 3.7-2.9-2.7-1.3-1.2 1.1 1.1 2.3 2 3.4 3.1.9.9 1.8 1.9 2.7 2.9 3.3 3.6-4.8-6.9-.8-.8 1.7 2.6 3.1 5.3 4.3 8.1l-3-7.2c1.7 4.2 2.9 8.5 3.5 12.9-.4-2.7-.7-5.3-1.1-8 .8 6.7.5 13.6.5 20.4v472.1c0 21.9.2 43.8 0 65.7 0 2.5-.2 5-.5 7.5.4-2.7.7-5.3 1.1-8-.7 4.5-1.8 8.8-3.5 12.9l3-7.2c-1.2 2.8-2.7 5.5-4.3 8.1-3.7 5.6 2.7-2.9 1.2-1.3-1.1 1.1-2 2.3-3.1 3.4-.9.9-1.9 1.8-2.9 2.7-3.6 3.3 6.9-4.8.8-.8-2.6 1.7-5.3 3.1-8.1 4.3l7.2-3c-4.2 1.7-8.5 2.9-12.9 3.5 2.7-.4 5.3-.7 8-1.1-2 .2-4.3.3-6.7.3-15.7.2-30.7 13.6-30 30 .7 16.1 13.2 30.2 30 30 25.2-.3 48.6-11.7 64-31.7 11.1-14.3 16.9-31.5 17.1-49.7.1-5.6 0-11.1 0-16.7V338.7c0-26.8 3-56-12.8-79.4-14.9-22.1-37.5-35-64.1-37.2-2.7-.2-5.4-.2-8.1-.2H502.8c7.1 2.9 14.1 5.9 21.2 8.8-23.1-26.6-46.2-53.3-69.3-79.9-10.8-12.4-21.5-24.8-32.3-37.3C407.2 96 385.9 88 363.1 88H131.5c-14.7 0-29.4-.5-43.3 5.1-23.7 9.4-40.9 27.1-49.3 51.2-2.8 8.2-3.9 17.2-3.9 25.8-.1 16.1 0 32.3 0 48.4V824.5c0 18.8-2 40.3 5.1 57.9 9.5 23.5 26.7 40.4 50.6 49.1 8.3 3 17.5 4.1 26.3 4.1h790.9c15.7 0 30.7-13.8 30-30-.7-16-13.1-29.8-30-29.8z"></path>
      <path d="M907.9 875.8H116.7c-2.6 0-5.2-.1-7.8-.5 2.7.4 5.3.7 8 1.1-4.5-.7-8.8-1.8-12.9-3.5l7.2 3c-2.8-1.2-5.5-2.6-8.1-4.3-5.6-3.7 2.9 2.7 1.3 1.2-1.1-1.1-2.3-2-3.4-3.1-.9-.9-1.8-1.9-2.7-2.9-3.3-3.6 4.8 6.9.8.8-1.7-2.6-3.1-5.3-4.3-8.1l3 7.2c-1.7-4.2-2.9-8.5-3.5-12.9.4 2.7.7 5.3 1.1 8-.8-6.7-.5-13.6-.5-20.4V369.3c0-21.9-.2-43.8 0-65.7 0-2.5.2-5 .5-7.5-.4 2.7-.7 5.3-1.1 8 .7-4.5 1.8-8.8 3.5-12.9l-3 7.2c1.2-2.8 2.6-5.5 4.3-8.1 3.7-5.6-2.7 2.9-1.2 1.3 1.1-1.1 2-2.3 3.1-3.4.9-.9 1.9-1.8 2.9-2.7 3.6-3.3-6.9 4.8-.8.8 2.6-1.7 5.3-3.1 8.1-4.3l-7.2 3c4.2-1.7 8.5-2.9 12.9-3.5-2.7.4-5.3.7-8 1.1 8.8-1.1 17.9-.5 26.7-.5H906.9c2.6 0 5.2.1 7.8.5-2.7-.4-5.3-.7-8-1.1 4.5.7 8.8 1.8 12.9 3.5l-7.2-3c2.8 1.2 5.5 2.6 8.1 4.3 5.6 3.7-2.9-2.7-1.3-1.2 1.1 1.1 2.3 2 3.4 3.1.9.9 1.8 1.9 2.7 2.9 3.3 3.6-4.8-6.9-.8-.8 1.7 2.6 3.1 5.3 4.3 8.1l-3-7.2c1.7 4.2 2.9 8.5 3.5 12.9-.4-2.7-.7-5.3-1.1-8 .8 6.7.5 13.6.5 20.4v472.1c0 21.9.2 43.8 0 65.7 0 2.5-.2 5-.5 7.5.4-2.7.7-5.3 1.1-8-.7 4.5-1.8 8.8-3.5 12.9l3-7.2c-1.2 2.8-2.7 5.5-4.3 8.1-3.7 5.6 2.7-2.9 1.2-1.3-1.1 1.1-2 2.3-3.1 3.4-.9.9-1.9 1.8-2.9 2.7-3.6 3.3 6.9-4.8.8-.8-2.6 1.7-5.3 3.1-8.1 4.3l7.2-3c-4.2 1.7-8.5 2.9-12.9 3.5 2.7-.4 5.3-.7 8-1.1-2.1.4-4.4.5-6.8.5-15.7.2-30.7 13.6-30 30 .7 16.1 13.2 30.2 30 30 35.5-.5 65.6-23 77.2-56.3 3.1-9 3.9-18.8 3.9-28.3V303c-.2-14.8-4.1-30.1-12.1-42.6-10-15.7-24-26.5-41.1-33.4-13-5.3-26.7-5.1-40.4-5.1H120.1c-2.3 0-4.7 0-7 .1-34.7 2-65.2 25.1-75 59-3.9 13.4-3.1 27.7-3.1 41.5v507.7c0 8.2-.1 16.4 0 24.6.2 15.6 4.5 31.9 13.6 44.8 10.6 15.1 24.3 25.5 41.5 31.9 9 3.4 18.8 4.3 28.4 4.3H908.1c15.7 0 30.7-13.8 30-30-.9-16.2-13.3-30-30.2-30z"></path>
    </svg>
  );
};

export const BackIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-caret-left-fill"
      viewBox="0 0 16 16"
    >
      <path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z" />
    </svg>
  );
};

export const SpinnerIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
      <g>
        <circle cx="12" cy="2.5" r="1.5" fill="currentColor" opacity="0.5" />
        <circle cx="16.75" cy="3.77" r="1.5" fill="currentColor" opacity="0.5" />
        <circle cx="20.23" cy="7.25" r="1.5" fill="currentColor" opacity="0.5" />
        <circle cx="21.5" cy="12" r="1.5" fill="currentColor" opacity="0.57" />
        <circle cx="20.23" cy="16.75" r="1.5" fill="currentColor" opacity="0.71" />
        <circle cx="16.75" cy="20.23" r="1.5" fill="currentColor" opacity="0.86" />
        <circle cx="12" cy="21.5" r="1.5" fill="currentColor" />
        <animateTransform
          attributeName="transform"
          calcMode="discrete"
          dur="0.75s"
          repeatCount="indefinite"
          type="rotate"
          values="0 12 12;30 12 12;60 12 12;90 12 12;120 12 12;150 12 12;180 12 12;210 12 12;240 12 12;270 12 12;300 12 12;330 12 12;360 12 12"
        />
      </g>
    </svg>
  );
};

export const EXLDownloadIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30.037" height="28.37" viewBox="0 0 30.037 28.37">
      <g id="noun-excel-1194546" transform="translate(-0.001)">
        <path
          id="Path_13743"
          data-name="Path 13743"
          d="M35.51,46.788V22.41H33.541c-5.056.913-10.1,1.758-15.171,2.635V48.1c4.992.881,10.047,1.763,15.071,2.676H35.5V46.788Zm-7.435-5.06a38.887,38.887,0,0,1-1.653-4.138c-.457,1.338-1.087,2.6-1.6,3.909-.722,0-1.443-.041-2.165-.069.845-1.658,1.662-3.329,2.535-4.973-.74-1.7-1.557-3.361-2.32-5.046l2.183-.123c.489,1.288,1.028,2.562,1.434,3.882.457-1.4,1.082-2.74,1.64-4.074q1.119-.078,2.242-.137-1.315,2.7-2.653,5.421c.913,1.827,1.827,3.676,2.74,5.521C29.66,41.838,28.869,41.788,28.075,41.728Z"
          transform="translate(-18.369 -22.41)"
          fill="#fff"
        />
        <path
          id="Path_13744"
          data-name="Path 13744"
          d="M57.72,29.33v1.749h3.494v2.58H57.72v1.416h3.494v2.58H57.72v1.416h3.494v2.576H57.72v1.416h3.494V45.62H57.72v1.5h3.494v2.5H57.72v1.749H69.786V29.33Zm9.4,20.3H62.045v-2.5h5.078Zm0-4H62.045v-2.58h5.078Zm0-4H62.045V39.067h5.078Zm0-4H62.045V35.071h5.078Zm0-4H62.045V31.079h5.078Z"
          transform="translate(-39.748 -26.17)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export const PDFDownloadIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20.441" height="28.87" viewBox="0 0 20.441 28.87">
      <g id="noun-pdf-3836262" transform="translate(0.25 0.254)">
        <g id="Group_2726" data-name="Group 2726" transform="translate(0 0)">
          <path
            id="Path_13738"
            data-name="Path 13738"
            d="M35.108,41.181a1.251,1.251,0,0,1-.967-.465,1.277,1.277,0,0,1-.036-1.754,4.583,4.583,0,0,1,2.076-1.217,10.7,10.7,0,0,1,1.146-.322,14.655,14.655,0,0,0,.716-1.5,14.31,14.31,0,0,0,.537-1.432,6.269,6.269,0,0,1-1.074-3.007,1.318,1.318,0,0,1,1.217-1.4h0a1.234,1.234,0,0,1,1.4.9,6.522,6.522,0,0,1-.322,3.329,11.3,11.3,0,0,0,1,1.4c.322.394.609.752.931,1.11a7.171,7.171,0,0,1,3.15.5,1.269,1.269,0,0,1,.716,1.539,1.286,1.286,0,0,1-1.5.967,5.664,5.664,0,0,1-2.828-1.862,18.094,18.094,0,0,0-1.862.179c-.465.072-.931.143-1.36.251a6.9,6.9,0,0,1-.465.752,6.1,6.1,0,0,1-1.718,1.826A1.5,1.5,0,0,1,35.108,41.181Zm1.4-2.363a3.884,3.884,0,0,0-1.575.859c-.107.107-.107.179.036.358.072.072.107.143.394,0A4.765,4.765,0,0,0,36.5,38.818Zm6.372-.823a2.885,2.885,0,0,0,1.36.788c.143.036.215.036.322-.215.036-.072.036-.107-.179-.251A4.509,4.509,0,0,0,42.876,37.994Zm-3.508-2.327c-.107.286-.215.537-.286.716-.107.286-.251.537-.358.788a2.763,2.763,0,0,1,.537-.072c.358-.036.716-.107,1.074-.107-.179-.215-.322-.394-.394-.5C39.8,36.276,39.583,35.989,39.368,35.667Zm-.5-4.475c-.143.036-.251.036-.251.322a3.759,3.759,0,0,0,.43,1.468,3.638,3.638,0,0,0,.072-1.611c-.072-.179-.107-.179-.251-.179Z"
            transform="translate(-29.63 -23.053)"
            fill="#fff"
          />
          <g id="Group_2725" data-name="Group 2725" transform="translate(5.084 20.133)">
            <path
              id="Path_13739"
              data-name="Path 13739"
              d="M36.4,67.165a.432.432,0,0,1,.465-.465h1.181a1.378,1.378,0,0,1,1.468,1.432,1.334,1.334,0,0,1-1.432,1.432h-.716v.9a.461.461,0,0,1-.465.5.443.443,0,0,1-.465-.5V67.165Zm.967,1.539h.5a.607.607,0,0,0,.644-.573c0-.394-.251-.573-.644-.573h-.5Z"
              transform="translate(-36.4 -66.7)"
              fill="#fff"
            />
            <path
              id="Path_13740"
              data-name="Path 13740"
              d="M46.5,67.165a.432.432,0,0,1,.465-.465h1.146a2.117,2.117,0,0,1,0,4.224H46.965a.451.451,0,0,1-.465-.465Zm.967,2.864h.5c.752,0,1.11-.5,1.11-1.253,0-.716-.358-1.181-1.074-1.181h-.537Z"
              transform="translate(-42.884 -66.7)"
              fill="#fff"
            />
            <path
              id="Path_13741"
              data-name="Path 13741"
              d="M58.1,67.165a.432.432,0,0,1,.465-.465h1.468a.424.424,0,0,1,.465.43c0,.286-.179.43-.465.43h-1v.752h.859a.424.424,0,0,1,.465.43c0,.286-.179.43-.465.43h-.859v1.217a.461.461,0,0,1-.465.5.443.443,0,0,1-.465-.5Z"
              transform="translate(-50.331 -66.7)"
              fill="#fff"
            />
          </g>
          <path
            id="Path_13742"
            data-name="Path 13742"
            d="M41.568,17.923a.551.551,0,0,0-.537.537V36.575a1.115,1.115,0,0,1-1.11,1.11H24.384a1.115,1.115,0,0,1-1.11-1.11V12.661a1.115,1.115,0,0,1,1.11-1.11H35.7V14.88a1.987,1.987,0,0,0,1.969,1.969h3.866a.561.561,0,0,0,.5-.322.64.64,0,0,0-.107-.609l-5.3-5.3a.491.491,0,0,0-.465-.143H24.42A2.231,2.231,0,0,0,22.2,12.7V36.611a2.231,2.231,0,0,0,2.22,2.22h15.5a2.231,2.231,0,0,0,2.22-2.22V18.46A.583.583,0,0,0,41.568,17.923Zm-3.9-2.184a.886.886,0,0,1-.9-.9V12.267l3.473,3.473Z"
            transform="translate(-22.2 -10.464)"
            fill="#fff"
            stroke="#fff"
            strokeWidth="0.5"
          />
        </g>
      </g>
    </svg>
  );
};

export const DownloadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-download"
      viewBox="0 0 16 16"
    >
      <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
      <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
    </svg>
  );
};

export const ProductStatIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17.886" height="20.648" viewBox="0 0 17.886 20.648">
      <path
        id="Path_19196"
        data-name="Path 19196"
        d="M18.085,12.464v9.377L25.8,17.519V8.142ZM26.27,7.3a.325.325,0,0,1,.183.292V17.709h0a.323.323,0,0,1-.166.283L17.934,22.67a.329.329,0,0,1-.174.051.322.322,0,0,1-.174-.051L9.249,18a.325.325,0,0,1-.183-.292V7.587A.325.325,0,0,1,9.249,7.3L17.6,2.619a.326.326,0,0,1,.321,0l3.067,1.717.006,0,2.217,1.242.006,0ZM9.716,8.142v9.377l7.718,4.322V12.464l-2.422-1.357v3.159h0a.324.324,0,0,1-.595.179l-1.025-1.539-.719.526a.325.325,0,0,1-.534-.249V9.5Zm4.646,2.6-1.573-.881v2.682l.494-.361a.324.324,0,0,1,.453.07l.009.012.617.927Zm11.1-3.156-7.7,4.315L15.35,10.553l7.7-4.314ZM22.391,5.867l-7.7,4.315-1.559-.873L20.832,5ZM20.168,4.623l-7.7,4.314L10.055,7.587l7.7-4.314Zm3.19,13.242-3.713,2.2a.325.325,0,0,1-.489-.3l.007-2.139a.323.323,0,0,1,.159-.279l3.713-2.2a.325.325,0,0,1,.489.3l-.007,2.139a.323.323,0,0,1-.159.279Zm-3.552,1.346,0-1.407,3.065-1.811,0,1.407Zm-.3-2.926a.324.324,0,0,1-.317-.566l2.227-1.247a.324.324,0,1,1,.317.566Z"
        transform="translate(-8.816 -2.322)"
        fill="#929292"
        stroke="#929292"
        strokeWidth="0.5"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const StoreStatIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19.043" height="18.583" viewBox="0 0 19.043 18.583">
      <g id="Group_7673" data-name="Group 7673" transform="translate(-62.893 -67.866)">
        <g id="Group_7691" data-name="Group 7691" transform="translate(62.993 67.966)">
          <g id="Group_7690" data-name="Group 7690" transform="translate(0 0)">
            <g id="Group_7688" data-name="Group 7688" transform="translate(0.465)">
              <g id="Group_7673-2" data-name="Group 7673" transform="translate(1.099 6.102)">
                <path
                  id="Path_19197"
                  data-name="Path 19197"
                  d="M107.919,197.206H92.8a.3.3,0,0,1-.3-.3V186.6a.3.3,0,1,1,.593,0v10.022h14.529V186.6a.3.3,0,0,1,.593,0v10.318A.3.3,0,0,1,107.919,197.206Z"
                  transform="translate(-92.5 -186.3)"
                  fill="#929292"
                  stroke="#929292"
                  strokeWidth="0.2"
                  fillRule="evenodd"
                />
              </g>
              <g id="Group_7674" data-name="Group 7674" transform="translate(8.52 8.08)">
                <path
                  id="Path_19198"
                  data-name="Path 19198"
                  d="M244.221,232.012H238a.3.3,0,0,1-.3-.3V225.3a.3.3,0,0,1,.3-.3h6.22a.3.3,0,0,1,.3.3v6.424a.288.288,0,0,1-.291.291Zm-5.928-.588h5.632v-5.836h-5.632v5.836Z"
                  transform="translate(-237.7 -225)"
                  fill="#929292"
                  stroke="#929292"
                  strokeWidth="0.2"
                  fillRule="evenodd"
                />
              </g>
              <g id="Group_7677" data-name="Group 7677" transform="translate(10.331 10.433)">
                <g id="Group_7675" data-name="Group 7675" transform="translate(0)">
                  <path
                    id="Path_19199"
                    data-name="Path 19199"
                    d="M273.446,273.268a.3.3,0,0,1-.22-.1.292.292,0,0,1,.026-.414l1.845-1.63a.293.293,0,0,1,.388.439l-1.845,1.63A.278.278,0,0,1,273.446,273.268Z"
                    transform="translate(-273.152 -271.052)"
                    fill="#929292"
                    stroke="#929292"
                    strokeWidth="0.2"
                    fillRule="evenodd"
                  />
                </g>
                <g id="Group_7676" data-name="Group 7676" transform="translate(1.513 0.711)">
                  <path
                    id="Path_19200"
                    data-name="Path 19200"
                    d="M303.051,286.554a.274.274,0,0,1-.215-.1.292.292,0,0,1,.015-.414l1.094-1.007a.293.293,0,0,1,.4.429l-1.094,1.007A.278.278,0,0,1,303.051,286.554Z"
                    transform="translate(-302.757 -284.957)"
                    fill="#929292"
                    stroke="#929292"
                    strokeWidth="0.2"
                    fillRule="evenodd"
                  />
                </g>
              </g>
              <g id="Group_7685" data-name="Group 7685">
                <g id="Group_7678" data-name="Group 7678">
                  <path
                    id="Path_19201"
                    data-name="Path 19201"
                    d="M88.617,71.571a.3.3,0,0,1-.266-.164l-1.937-3.92H73.49l-1.937,3.92a.294.294,0,1,1-.526-.261l2.019-4.083a.3.3,0,0,1,.266-.164H86.6a.3.3,0,0,1,.266.164l2.019,4.083a.3.3,0,0,1-.133.394A.377.377,0,0,1,88.617,71.571Z"
                    transform="translate(-70.996 -66.9)"
                    fill="#929292"
                    stroke="#929292"
                    strokeWidth="0.2"
                    fillRule="evenodd"
                  />
                </g>
                <g id="Group_7679" data-name="Group 7679" transform="translate(0 4.078)">
                  <path
                    id="Path_19202"
                    data-name="Path 19202"
                    d="M72.738,149.352A1.739,1.739,0,0,1,71,147.615V147a.3.3,0,0,1,.3-.3h2.887a.3.3,0,0,1,.3.3v.618a1.744,1.744,0,0,1-1.743,1.738Zm-1.15-2.06v.322a1.152,1.152,0,0,0,1.15,1.15h0a1.152,1.152,0,0,0,1.15-1.15v-.322Z"
                    transform="translate(-71 -146.7)"
                    fill="#929292"
                    stroke="#929292"
                    strokeWidth="0.2"
                    fillRule="evenodd"
                  />
                </g>
                <g id="Group_7680" data-name="Group 7680" transform="translate(2.888 4.078)">
                  <path
                    id="Path_19203"
                    data-name="Path 19203"
                    d="M129.238,149.352a1.739,1.739,0,0,1-1.738-1.738V147a.3.3,0,0,1,.3-.3h2.887a.3.3,0,0,1,.3.3v.618a1.744,1.744,0,0,1-1.743,1.738Zm-1.15-2.06v.322a1.15,1.15,0,0,0,2.3,0v-.322Z"
                    transform="translate(-127.5 -146.7)"
                    fill="#929292"
                    stroke="#929292"
                    strokeWidth="0.2"
                    fillRule="evenodd"
                  />
                </g>
                <g id="Group_7681" data-name="Group 7681" transform="translate(5.775 4.078)">
                  <path
                    id="Path_19204"
                    data-name="Path 19204"
                    d="M185.738,149.352A1.739,1.739,0,0,1,184,147.615V147a.3.3,0,0,1,.3-.3h2.887a.3.3,0,0,1,.3.3v.618a1.744,1.744,0,0,1-1.743,1.738Zm-1.15-2.06v.322a1.152,1.152,0,0,0,1.15,1.15h0a1.152,1.152,0,0,0,1.15-1.15v-.322Z"
                    transform="translate(-184 -146.7)"
                    fill="#929292"
                    stroke="#929292"
                    strokeWidth="0.2"
                    fillRule="evenodd"
                  />
                </g>
                <g id="Group_7682" data-name="Group 7682" transform="translate(8.663 4.078)">
                  <path
                    id="Path_19205"
                    data-name="Path 19205"
                    d="M242.238,149.352a1.739,1.739,0,0,1-1.738-1.738V147a.3.3,0,0,1,.3-.3h2.887a.3.3,0,0,1,.3.3v.618a1.744,1.744,0,0,1-1.743,1.738Zm-1.15-2.06v.322a1.15,1.15,0,0,0,2.3,0v-.322Z"
                    transform="translate(-240.5 -146.7)"
                    fill="#929292"
                    stroke="#929292"
                    strokeWidth="0.2"
                    fillRule="evenodd"
                  />
                </g>
                <g id="Group_7683" data-name="Group 7683" transform="translate(11.55 4.078)">
                  <path
                    id="Path_19206"
                    data-name="Path 19206"
                    d="M298.738,149.352A1.739,1.739,0,0,1,297,147.615V147a.3.3,0,0,1,.3-.3h2.887a.3.3,0,0,1,.3.3v.618a1.744,1.744,0,0,1-1.743,1.738Zm-1.15-2.06v.322a1.152,1.152,0,0,0,1.15,1.15h0a1.152,1.152,0,0,0,1.15-1.15v-.322Z"
                    transform="translate(-297 -146.7)"
                    fill="#929292"
                    stroke="#929292"
                    strokeWidth="0.2"
                    fillRule="evenodd"
                  />
                </g>
                <g id="Group_7684" data-name="Group 7684" transform="translate(14.438 4.078)">
                  <path
                    id="Path_19207"
                    data-name="Path 19207"
                    d="M355.238,149.352a1.739,1.739,0,0,1-1.738-1.738V147a.3.3,0,0,1,.3-.3h2.887a.3.3,0,0,1,.3.3v.618a1.744,1.744,0,0,1-1.743,1.738Zm-1.15-2.06v.322a1.15,1.15,0,0,0,2.3,0v-.322Z"
                    transform="translate(-353.5 -146.7)"
                    fill="#929292"
                    stroke="#929292"
                    strokeWidth="0.2"
                    fillRule="evenodd"
                  />
                </g>
              </g>
              <g id="Group_7686" data-name="Group 7686" transform="translate(2.591 8.08)">
                <path
                  id="Path_19208"
                  data-name="Path 19208"
                  d="M126.325,233.928H122a.3.3,0,0,1-.3-.3V225.3a.3.3,0,0,1,.3-.3h4.329a.3.3,0,0,1,.3.3v8.34a.3.3,0,0,1-.3.291Zm-4.037-.588h3.741v-7.753h-3.741Z"
                  transform="translate(-121.7 -225)"
                  fill="#929292"
                  stroke="#929292"
                  strokeWidth="0.2"
                  fillRule="evenodd"
                />
              </g>
              <g id="Group_7687" data-name="Group 7687" transform="translate(5.775 10.962)">
                <path
                  id="Path_19209"
                  data-name="Path 19209"
                  d="M184.3,283.659a.3.3,0,0,1-.3-.3V281.7a.3.3,0,0,1,.593,0v1.666A.3.3,0,0,1,184.3,283.659Z"
                  transform="translate(-184 -281.4)"
                  fill="#929292"
                  stroke="#929292"
                  strokeWidth="0.2"
                  fillRule="evenodd"
                />
              </g>
            </g>
            <g id="Group_7689" data-name="Group 7689" transform="translate(0 16.415)">
              <path
                id="Path_19210"
                data-name="Path 19210"
                d="M80.446,390.068H62.2a.3.3,0,0,1-.3-.3V388.4a.3.3,0,0,1,.3-.3h18.25a.3.3,0,0,1,.3.3v1.375a.3.3,0,0,1-.3.3Zm-17.953-.588H80.155v-.787H62.493Z"
                transform="translate(-61.9 -388.1)"
                fill="#929292"
                stroke="#929292"
                strokeWidth="0.2"
                fillRule="evenodd"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const EnlargeIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="27.128" height="27.128" viewBox="0 0 27.128 27.128">
      <path
        id="Path_6"
        data-name="Path 6"
        d="M25.433,3.391a1.7,1.7,0,0,0-1.7-1.7H3.391a1.7,1.7,0,0,0-1.7,1.7V23.737a1.7,1.7,0,0,0,1.7,1.7H23.737a1.7,1.7,0,0,0,1.7-1.7ZM0,3.391A3.391,3.391,0,0,1,3.391,0H23.737a3.391,3.391,0,0,1,3.391,3.391V23.737a3.391,3.391,0,0,1-3.391,3.391H3.391A3.391,3.391,0,0,1,0,23.737ZM9.925,18.317a.848.848,0,0,1-1.2-1.2l6.946-6.945H10.978a.848.848,0,0,1,0-1.7h6.74a.848.848,0,0,1,.848.848v6.74a.848.848,0,1,1-1.7,0V11.372Z"
        fill="#000"
        fill-rule="evenodd"
        opacity="1"
      ></path>
    </svg>
  );
};
